export const times = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

export const selectDates = ["1 day", "2 days", "3 days", "1 week", "2 weeks"];

export const selectDatesDictionary = {
  "1 day": 1,
  "2 days": 2,
  "3 days": 3,
  "1 week": 7,
  "2 weeks": 14,
  1: "1 day",
  2: "2 days",
  3: "3 days",
  7: "1 week",
  14: "2 weeks"
};

export const getSelectDatesDictionaryValue = (key: any) => {
  const k = key as keyof typeof selectDatesDictionary;
  return selectDatesDictionary[k];
}

export const dayDictionary = {
  Sun: "Sunday",
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thu: "Thursday",
  Fri: "Friday",
  Sat: "Saturday"
};

export const durationObject = {
  2940: "h-8-m-10",
  2880: "h-8-m-0",
  2520: "h-7-m-0",
  2340: "h-6-m-30",
  2160: "h-6-m-0",
  2130: "h-5-m-55",
  1800: "h-5-m-0",
  1620: "h-4-m-30",
  1590: "h-4-m-25",
  1470: "h-4-m-5",
  1440: "h-4-m-0",
  1290: "h-3-m-45",
  1260: "h-3-m-30",
  1230: "h-3-m-25",
  1200: "h-3-m-20",
  1170: "h-3-m-15",
  1140: "h-3-m-10",
  1110: "h-3-m-5",
  1080: "h-3-m-0",
  1050: "h-2-m-55",
  1020: "h-2-m-50",
  990: "h-2-m-45",
  960: "h-2-m-40",
  930: "h-2-m-35",
  900: "h-2-m-30",
  870: "h-2-m-25",
  840: "h-2-m-20",
  810: "h-2-m-15",
  780: "h-2-m-10",
  750: "h-2-m-5",
  720: "h-2-m-0",
  690: "h-1-m-55",
  660: "h-1-m-50",
  630: "h-1-m-45",
  600: "h-1-m-40",
  570: "h-1-m-35",
  540: "h-1-m-30",
  510: "h-1-m-25",
  480: "h-1-m-20",
  450: "h-1-m-15",
  420: "h-1-m-10",
  390: "h-1-m-5",
  360: "h-1-m-0",
  330: "h-0-m-55",
  300: "h-0-m-50",
  270: "h-0-m-45",
  240: "h-0-m-40",
  210: "h-0-m-35",
  180: "h-0-m-30",
  150: "h-0-m-25",
  120: "h-0-m-20",
  90: "h-0-m-15",
  60: "h-0-m-10",
  30: "h-0-m-5",
};
